import { Routes, Route } from "react-router-dom";
import { lazy, Suspense } from "react";
import {
  AuthProvider,
  NotificationProvider as SharedNotificationProvider,
  PrivateRoute,

  MidtransScript,
  TentangKami,
  Register,
  Actions,
  Verify,
  LupaPassword,
  Sukses,
  EntryList,
  Xtrifeinnie,
  // SectionKategori, // REMOVED: Using local
  // KegiatanDetail, // REMOVED: Using local
  // Schedule, // REMOVED: Using local
  // Kontak, // REMOVED: Using local

  EntryListPage,

  FormPendaftaranVolunteer,
  RaceRegulations,
  Participants,
  ParticipantsEdit,
  Gallery,

  RegistrationDetail,
  SyaratKetentuan,
  KebijakanPrivasi,
  VoucherManagement,
} from "@jotrseatrc/shared-components";

import { SuratPernyataan } from "./pages/SuratPernyataan";

import { NotificationProvider } from "./common/NotificationContext";

import { FormPendaftaran } from "./form/FormPendaftaran";
import { MyRegistration } from "./pages/MyRegistration";
import { Profile } from "./pages/Profile";
import { Login } from "./pages/Login";
import { KegiatanDetail } from "./pages/KegiatanDetail";
import { Information } from "./pages/Information";
import { Schedule } from "./pages/Schedule";
import { Kontak } from "./pages/Kontak";
import { SectionKategori } from "./sections/SectionKategori";

import Beranda from "./Beranda";
import { Layout } from "./components/Layout";

const App = () => {
  return (
    <AuthProvider>
      <SharedNotificationProvider>
        <NotificationProvider>
          <MidtransScript />
          <Suspense fallback={null}>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<Beranda />} />
              <Route path="kategori" element={<SectionKategori />} />
              <Route
                path="SEATRC/:categoryId"
                element={<KegiatanDetail />}
              />
              <Route path="entrylist/:eventId" element={<EntryList />} />
              <Route path="entrylistpage" element={<EntryListPage />} />
              <Route
                path="Xtrifeinnie"
                element={
                  <PrivateRoute>
                    <Xtrifeinnie />
                  </PrivateRoute>
                }
              />
            
              <Route path="RaceRegulations" element={<RaceRegulations />} />
            
              <Route path="Participants" element={<Participants />} />
              <Route path="/participants/edit" element={<ParticipantsEdit />} />
              <Route path="Information" element={<Information />} />
              <Route path="Schedule" element={<Schedule />} />
              <Route path="Tentangkami" element={<TentangKami />} />
              <Route path="Kontak" element={<Kontak />} />
              <Route path="Login" element={<Login />} />
              <Route path="Register" element={<Register />} />
              <Route path="MyRegistration" element={<MyRegistration />} />
              <Route
                path="/RegistrationDetail"
                element={<RegistrationDetail />}
              />
   
              <Route path="SyaratKetentuan" element={<SyaratKetentuan />} />
              <Route path="KebijakanPrivasi" element={<KebijakanPrivasi />} />
              <Route path="SuratPernyataan" element={<SuratPernyataan />} />
              <Route path="Sukses" element={<Sukses />} />
              <Route path="Actions" element={<Actions />} />
              <Route path="Verify" element={<Verify />} />
              <Route path="LupaPassword" element={<LupaPassword />} />
              <Route path="form/:slug" element={<FormPendaftaran />} />
              <Route path="Gallery" element={<Gallery />} />
              <Route path="VoucherManagement" element={<VoucherManagement />} />
              <Route
                path="form-volunteer"
                element={
                  <PrivateRoute>
                    <FormPendaftaranVolunteer />
                  </PrivateRoute>
                }
              />
              <Route
                path="Profile"
                element={
                  <PrivateRoute>
                    <Profile />
                  </PrivateRoute>
                }
              />
            </Route>
          </Routes>
        </Suspense>
      </NotificationProvider>
    </SharedNotificationProvider>
    </AuthProvider>
  );
};

export default App;
